module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Anointing")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long-new"
  }, [_vm._v("Aching heart and weary limbs")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("crave anointing with the salve of love")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("deep mind open to the well of fire")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long-new"
  }, [_vm._v("Harrowed, broken, old pains recalled ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("stuff no man should ever need to hear")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("deep wounds slashed on who we are")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long-new"
  }, [_vm._v("Soothed by love’s gentle balm, washed ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("by Christ’s new love, bloody and alive,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-long"
  }, [_vm._v("touched and healed, heartbeat strong.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373f1922","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-11.vue
// module id = 90
// module chunks = 0